import React, { FC } from 'react';

import clsx from 'clsx';

import InfoLabel from '~/components/atoms/InfoLabel';

import styles from './styles.module.scss';

export interface TabProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  infoLabel?: string;
  disabled?: boolean;
  EndIcon?: FC;
}

const Tab: FC<TabProps> = ({
  label,
  isActive,
  infoLabel,
  disabled,
  EndIcon,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={clsx(styles.tab, {
        [styles['tab--active']]: isActive,
        [styles['tab--disabled']]: disabled,
      })}
    >
      {label}
      {EndIcon ? <EndIcon /> : null}
      {infoLabel ? (
        <InfoLabel className={styles.tab__label} text={infoLabel} />
      ) : null}
    </div>
  );
};

export default Tab;
